import { render, staticRenderFns } from "./page3part2.vue?vue&type=template&id=55675da2&scoped=true"
var script = {}
import style0 from "./page3part2.vue?vue&type=style&index=0&id=55675da2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55675da2",
  null
  
)

export default component.exports